/** Used for "protected" note badge (replaces faCertificate) */
export function ImgShield({ size = 16 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2L4 6v6c0 4.418 3.358 8.527 8 9.93C16.642 20.527 20 16.418 20 12V6L12 2z" />
      <path d="M9 12l2 2 4-4" />
    </svg>
  );
}
